(function () {
  const POLICY_PATH_RE = /\/(policies\/privacy-policy|policies\/cookie-policy|pages\/privacy-preferences|pages\/privacy-preference-center|pages\/cookie-policy)(\/|$)/i;
  const POLICY_CONTENT_PATH_RE = /\/(policies\/privacy-policy|policies\/cookie-policy|pages\/privacy-policy|pages\/cookie-policy)(\/|$)/i;
  const CONSENT_EVENTS = ["visitorConsentCollected", "PandectesEvent_OnConsent"];

  function isPolicyPath() {
    return POLICY_PATH_RE.test(window.location.pathname);
  }

  function isPolicyContentPath() {
    return POLICY_CONTENT_PATH_RE.test(window.location.pathname);
  }

  function isExplicitYes(value) {
    return value === true || value === "yes" || value === "true" || value === 1 || value === "1";
  }

  function getVisitorConsent() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) {
      return null;
    }

    if (typeof window.Shopify.customerPrivacy.currentVisitorConsent === "function") {
      return window.Shopify.customerPrivacy.currentVisitorConsent();
    }

    if (typeof window.Shopify.customerPrivacy.getTrackingConsent === "function") {
      return window.Shopify.customerPrivacy.getTrackingConsent();
    }

    return null;
  }

  function hasMadeConsentChoice() {
    var consent = getVisitorConsent();

    if (!consent) {
      return false;
    }

    if (typeof consent === "string") {
      return consent === "yes" || consent === "no";
    }

    return ["marketing", "analytics", "preferences", "sale_of_data"].some(function (category) {
      return consent[category] === "yes" || consent[category] === "no" || typeof consent[category] === "boolean";
    });
  }

  function categoryAllowed(category) {
    if (isPolicyPath()) {
      return false; // Force block all trackers on policy pages
    }

    var consent = getVisitorConsent();

    if (!consent) {
      return false;
    }

    if (typeof consent === "string") {
      return isExplicitYes(consent);
    }

    return isExplicitYes(consent[category]);
  }

  function shouldBlockPageUntilChoice() {
    return !isPolicyPath() && !hasMadeConsentChoice();
  }

  function shouldShowBlockingOverlay(consentContainers) {
    return shouldBlockPageUntilChoice() && consentContainers.length > 0;
  }

  function onConsentChange(callback) {
    CONSENT_EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, callback);
      window.addEventListener(eventName, callback);
    });
  }

  function runWhenAllowed(category, callback) {
    var hasRun = false;

    function attempt() {
      if (hasRun || !categoryAllowed(category)) {
        return;
      }
      hasRun = true;
      callback();
    }

    onConsentChange(attempt);
    attempt();
  }

  function appendScript(src, callback) {
    if (!src) {
      if (callback) callback();
      return;
    }

    var existingScript = document.querySelector('script[src="' + src + '"]');

    if (existingScript) {
      if (existingScript.getAttribute("data-vego-loaded") === "true") {
        if (callback) callback();
      } else {
        if (callback) existingScript.addEventListener("load", callback);
      }
      return;
    }

    var script = document.createElement("script");
    script.src = src;
    script.async = false;
    
    script.addEventListener("load", function () {
      script.setAttribute("data-vego-loaded", "true");
      if (callback) callback();
    });

    document.head.appendChild(script);
  }

  function loadScriptsSequentially(scripts) {
    var queue = scripts.filter(Boolean);

    function next() {
      var src = queue.shift();
      if (!src) return;
      appendScript(src, next);
    }

    next();
  }

  // Inject CSS required for the blackout overlay and hiding elements
  function injectComplianceStyles() {
    if (document.getElementById("vego-consent-compliance-style")) {
      return;
    }

    var style = document.createElement("style");
    style.id = "vego-consent-compliance-style";
    style.textContent = [
      "html.vego-consent-scroll-locked,html.vego-consent-scroll-locked body{overflow:hidden!important;overscroll-behavior:none!important;touch-action:none!important;}",
      ".vego-consent-page-overlay{position:fixed;inset:0;background:rgba(0,0,0,.58);z-index:2147483000;}",
      "#pandectes-banner,.pd-cookie-banner-window,.pd-cp-ui,.cc-window{z-index:2147483600!important;}",
      ".vego-consent-hide-ui #pandectes-banner,.vego-consent-hide-ui .cc-window-wrapper,.vego-consent-hide-ui .cc-window,.vego-consent-hide-ui .cc-revoke,.vego-consent-hide-ui .pd-cookie-banner-window,.vego-consent-hide-ui .pd-cp-ui{display:none!important;visibility:hidden!important;pointer-events:none!important;}",
      ".cc-allow, .pd-dp-btn-accept, .pd-button-accept { display: none !important; }"
    ].join("");
    document.head.appendChild(style);
  }

  function setConsentUiHidden(hidden) {
    document.documentElement.classList.toggle("vego-consent-hide-ui", hidden);
  }

  function setPageScrollLocked(locked) {
    document.documentElement.classList.toggle("vego-consent-scroll-locked", locked);
  }

  function hideConsentUiOnPolicyPage() {
    var selectors = [
      "#pandectes-banner",
      ".cc-window-wrapper",
      ".cc-window",
      ".cc-revoke",
      ".pd-cookie-banner-window",
      ".pd-cp-ui",
      "[aria-label='cookieconsent']",
      "[aria-describedby='cookieconsent:desc']"
    ];

    Array.prototype.forEach.call(document.querySelectorAll(selectors.join(",")), function (element) {
      if (element instanceof HTMLElement) {
        element.style.setProperty("display", "none", "important");
        element.style.setProperty("visibility", "hidden", "important");
        element.style.setProperty("pointer-events", "none", "important");
      }
    });

    setOverlayVisible(false);
  }

  function setOverlayVisible(visible) {
    var existing = document.querySelector(".vego-consent-page-overlay");

    if (!visible) {
      setPageScrollLocked(false);
      if (existing) existing.remove();
      return;
    }

    setPageScrollLocked(true);
    if (!existing) {
      var overlay = document.createElement("div");
      overlay.className = "vego-consent-page-overlay";
      overlay.setAttribute("aria-hidden", "true");
      document.body.appendChild(overlay);
    }
  }

  function getVisibleConsentContainers() {
    var selectors = [
      "#pandectes-banner",
      ".pd-cookie-banner-window",
      ".pd-cp-ui",
      ".cc-window"
    ];

    return Array.prototype.filter.call(document.querySelectorAll(selectors.join(",")), function (element) {
      var isVisible = element.offsetWidth > 0 || element.offsetHeight > 0;

      return element instanceof HTMLElement
        && element.tagName !== "SCRIPT"
        && element.tagName !== "STYLE"
        && isVisible
        && !(element.id === "pandectes-banner" && element.querySelector(".pd-cookie-banner-window, .pd-cp-ui, .cc-window"))
        && !!element.querySelector("button, a")
        && !element.classList.contains("vego-consent-page-overlay");
    });
  }

  // Hijack links and buttons for compliance
  function enhanceConsentCopy(consentContainers) {
    consentContainers.forEach(function (container) {
      
      // 1. Hijack the hyperlinks in the text to open the modal instead of redirecting
      var settingsBtn = container.querySelector('.cc-settings, .pd-button-preferences, [aria-controls*="preferences"]');
      var textLinks = container.querySelectorAll('.vego-preference-trigger');

      if (settingsBtn && textLinks.length > 0) {
        textLinks.forEach(function(link) {
          if (!link.hasAttribute("data-vego-hijacked-link")) {
            link.setAttribute("data-vego-hijacked-link", "true");
            link.addEventListener("click", function(e) {
              e.preventDefault(); 
              e.stopImmediatePropagation();
              settingsBtn.click(); 
            });
          }
        });
      }

      // 2. LEGAL COMPLIANCE: Hijack the "X" button to trigger "Accept"
      var closeBtn = container.querySelector('.cc-close, .pd-close, .pd-banner-close, [aria-label*="Close"]');
      var acceptBtn = container.querySelector('.cc-allow, .pd-dp-btn-accept, .pd-button-accept, [data-action="accept"], button[id*="accept"]');

      if (closeBtn && acceptBtn) {
        if (!closeBtn.hasAttribute("data-vego-hijacked")) {
          closeBtn.setAttribute("data-vego-hijacked", "true");
          closeBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            acceptBtn.click(); 
          }, true); 
        }
      }
    });
  }

  function updateComplianceUi() {
    var shouldHideConsentUi = isPolicyContentPath();
    var consentContainers = getVisibleConsentContainers();

    injectComplianceStyles();
    setConsentUiHidden(shouldHideConsentUi);
    setOverlayVisible(!shouldHideConsentUi && shouldShowBlockingOverlay(consentContainers));
    if (shouldHideConsentUi) {
      hideConsentUiOnPolicyPage();
      return;
    }
    enhanceConsentCopy(consentContainers);
  }

  function initComplianceUi() {
    var updateScheduled = false;

    function scheduleComplianceUiUpdate() {
      if (updateScheduled) return;

      updateScheduled = true;
      window.requestAnimationFrame(function () {
        updateScheduled = false;
        updateComplianceUi();
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scheduleComplianceUiUpdate);
    } else {
      updateComplianceUi();
    }

    onConsentChange(scheduleComplianceUiUpdate);

    var observer = new MutationObserver(scheduleComplianceUiUpdate);
    if (document.documentElement) {
      observer.observe(document.documentElement, { 
        childList: true, 
        subtree: true,
        attributes: true, 
        attributeFilter: ['style', 'class'] 
      });
    }
  }

  window.VegoConsent = {
    categoryAllowed: categoryAllowed,
    hasMadeConsentChoice: hasMadeConsentChoice,
    onConsentChange: onConsentChange,
    runWhenAllowed: runWhenAllowed,
    appendScript: appendScript,
    loadScriptsSequentially: loadScriptsSequentially,
    isPolicyPath: isPolicyPath,
    initComplianceUi: initComplianceUi
  };

  initComplianceUi();
  window.dispatchEvent(new CustomEvent("VegoConsentReady"));
})();
